export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.companyId = item != null ? item.companyId : ''
        this.name = item != null ? item.name : '',
        this.tag = item != null ? item.tag : ''
        this.street = item != null ? item.address.street : ''
        this.city = item != null ? item.address.city : ''
        this.zipCode = item != null ? item.address.zipCode : ''
        this.postbox = item != null ? item.address.postBox : ''
        this.emailAddress = item != null ? item.emailAddress.address : ''
        this.phoneNumber = item != null ? item.phoneNumber.number : ''       
        this.websiteUrl = item != null ? item.websiteUrl : ''
    }
}